var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroreelHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 172,
    viewBox: "0 0 184 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.068 26.142c.512-7.118 6.698-12.473 13.816-11.961l102.584 7.378c7.117.512 12.472 6.696 11.961 13.814l-5.046 70.163c-.512 7.118-6.698 12.474-13.816 11.962L52.983 110.12c-7.117-.512-12.472-6.697-11.96-13.815l5.045-70.163z",
    stroke: "#2B8982",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.109,
    y: 52.168,
    width: 67.769,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(4.114 66.11 52.168)",
    fill: "#2B8982"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.438,
    y: 61.494,
    width: 78.833,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(4.114 65.438 61.494)",
    fill: "#2B8982"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.875,
    y: 71.045,
    width: 67.769,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(4.114 67.875 71.045)",
    fill: "#2B8982"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.426,
    y: 26.326,
    width: 21.818,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(4.114 54.426 26.326)",
    fill: "#2B8982"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 143.547,
    y: 32.736,
    width: 21.818,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(4.114 143.547 32.736)",
    fill: "#2B8982"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 138.551,
    y: 102.166,
    width: 21.818,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(4.114 138.551 102.166)",
    fill: "#2B8982"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51.953,
    y: 65.289,
    width: 23.512,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(4.114 51.953 65.29)",
    fill: "#2B8982"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.259 56.61c-1.4-7.561 3.594-14.825 11.154-16.224l50.78-9.4c7.56-1.4 14.824 3.594 16.224 11.154l17.59 95.015c1.399 7.56-3.595 14.824-11.155 16.223l-50.78 9.401c-7.56 1.4-14.824-3.595-16.224-11.155l-17.59-95.015z",
    fill: "#2B8982"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M68.174 85.8a2.257 2.257 0 00-2.284.537c-.605.572-.88 1.48-.721 2.384l2.297 12.41c.177.901.758 1.651 1.528 1.969.792.334 1.66.216 2.325-.317l9.173-7.384c.944-.713 1.4-2.013 1.16-3.311-.241-1.299-1.132-2.35-2.269-2.677L68.174 85.8z",
    stroke: "#F6F7F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.699,
    y: 146.457,
    width: 23.512,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(-10.488 49.7 146.457)",
    fill: "#F6F7F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50.605,
    y: 152.893,
    width: 45.534,
    height: 2.078,
    rx: 1.039,
    transform: "rotate(-10.488 50.605 152.893)",
    fill: "#F6F7F9"
  })));
}
export default SvgMicroreelHero;